export class EntTheNeedsOfThePopulationFilter {
    page: number;
    size: number;
    year?: number;
    regionId?: number;
    areaId?: number;
    territorialUnitId?: number;
    productTypeId?: number;
    deleted?: boolean;
  
    constructor(init?: Partial<EntTheNeedsOfThePopulationFilter>) {
      this.page = 1;
      this.size = 15;
      if (init) {
        Object.assign(this, init)
      }
    }
  }
  